/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailywinnerstitle3Inputs */

const en_dropdailywinnerstitle3 = /** @type {(inputs: Dropdailywinnerstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winners and vouchers`)
};

const de_dropdailywinnerstitle3 = /** @type {(inputs: Dropdailywinnerstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinner und Gutscheine`)
};

/**
* | output |
* | --- |
* | "Winners and vouchers" |
*
* @param {Dropdailywinnerstitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailywinnerstitle3 = /** @type {((inputs?: Dropdailywinnerstitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailywinnerstitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailywinnerstitle3(inputs)
	return de_dropdailywinnerstitle3(inputs)
});
export { dropdailywinnerstitle3 as "dropDailyWinnersTitle" }